var map = {
	"./arrow-down-blue.svg": 501,
	"./arrow-down-grey.svg": 502,
	"./arrow-right-white.png": 503,
	"./arrow-right.svg": 504,
	"./blue-loader.svg": 237,
	"./circle-grey.svg": 505,
	"./circle.svg": 506,
	"./coinbaseWalletIcon.svg": 145,
	"./dropdown-blue.svg": 507,
	"./dropdown.svg": 508,
	"./dropup-blue.svg": 509,
	"./ethereum-logo.png": 238,
	"./fortmaticIcon.png": 510,
	"./link.svg": 511,
	"./magnifying-glass.svg": 512,
	"./menu.svg": 513,
	"./metamask.png": 236,
	"./plus-blue.svg": 514,
	"./plus-grey.svg": 515,
	"./portisIcon.png": 516,
	"./question-mark.svg": 517,
	"./question.svg": 518,
	"./spinner.svg": 519,
	"./token-list-logo.png": 520,
	"./token-list/lists-dark.png": 521,
	"./token-list/lists-light.png": 522,
	"./trustWallet.png": 523,
	"./walletConnectIcon.svg": 146,
	"./x.svg": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;